export default "__VITE_ASSET__g27$hBOS__"